import { type PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface TitleProps extends PropsWithChildren {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export default function Title({
  className,
  size = 'md',
  ...props
}: TitleProps) {
  const mergedClasses = twMerge(classes.title, classes[size], className);
  if (size === 'xl') {
    return <h1 className={mergedClasses} {...props} />;
  }
  if (size === 'lg') {
    return <h2 className={mergedClasses} {...props} />;
  }
  if (size === 'md') {
    return <h3 className={mergedClasses} {...props} />;
  }
  if (size === 'sm') {
    return <h4 className={mergedClasses} {...props} />;
  }
  // xs is the only remaining option & handles the undefined case
  return <h5 className={mergedClasses} {...props} />;
}
